export class EmergencyTelehealthRoomUnavailableError extends Error {
	constructor() {
		super('Emergency telehealth room unavailable');
		this.name = 'EmergencyTelehealthRoomUnavailableError';
	}
}
